export interface WorldCountryStateInterface {
    countryCode: string;
    stateCode: string;
    name: string;
}
